export default "__VITE_ASSET__MgpGfNp6__"